import { Component, OnInit } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-no-access',
  templateUrl: './no-access.component.pug',
  styleUrls: ['./no-access.component.scss'],
  standalone: false
})
export class NoAccessComponent implements OnInit {

  constructor(private permission: PermissionsService) {}
  showButton = false;
  ngOnInit(): void {
  }

}
